export enum ColunasTabelaHostoricoModalEnum {
    DATA_HORA = 'dataHora',
    ALTERACAO = 'alteracao',
    USUARIO = 'usuario',
}
